import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'app-table-column-role',
  templateUrl: './table-column-role.component.html',
  styleUrls: ['./table-column-role.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableColumnRoleComponent implements OnInit {
  @Input() status: any;

  constructor() {}

  ngOnInit() {}
}
